export default "__VITE_ASSET__DBe13gze__"